import { render, staticRenderFns } from "./FitmentItemEdit.vue?vue&type=template&id=448fe2b6&scoped=true&"
import script from "./FitmentItemEdit.vue?vue&type=script&lang=js&"
export * from "./FitmentItemEdit.vue?vue&type=script&lang=js&"
import style0 from "./FitmentItemEdit.vue?vue&type=style&index=0&id=448fe2b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448fe2b6",
  null
  
)

export default component.exports